export const CONTACT = {
  phone: "06 14 25 43 35",
  phoneHref: "tel:+33614254335",
  email: "eg6.1@orange.fr",
  addressLine1: "Le Marais",
  addressLine2: "61200 Urou et Crennes / Gouffern-en-Auge",
  founders: ["Eric Gautier", "Mickaël Campos"],
  departments: ["Orne (61)", "Calvados (14)", "Sarthe (72)"],
  certifications: ["RGE", "Qualifelec", "IRVE"],
  zone: [
    "Argentan",
    "Urou et Crennes",
    "Gouffern-en-Auge",
    "Sées",
    "Écouché-les-Vallées",
    "Mortrée",
    "Flers",
    "Alençon",
  ],
};

export const SERVICES = [
  {
    id: "electricite-generale",
    num: "01",
    title: "Électricité Générale",
    baseline: "Résidentiel, tertiaire & industriel",
    description:
      "Toute l'électricité générale, en neuf comme en rénovation : tableaux électriques, mises aux normes, dépannages et éclairage intérieur / extérieur. Un courant sûr, pensé pour durer.",
    features: [
      "Neuf & rénovation, tous bâtiments",
      "Tableaux électriques & mise aux normes NF C 15-100",
      "Éclairage intérieur & extérieur",
      "Dépannage résidentiel, tertiaire & industriel",
    ],
    img: "/assets/real-electricite.jpg",
  },
  {
    id: "domotique",
    num: "02",
    title: "Domotique & Maison Connectée",
    baseline: "Votre habitat piloté du bout des doigts",
    description:
      "Éclairage, volets, scénarios : pilotez les équipements de votre logement depuis un interrupteur, une commande centrale ou votre smartphone. Contrôle à distance et optimisation énergétique inclus.",
    features: [
      "Maison connectée : éclairage, volets, scénarios",
      "Contrôle à distance & smartphone",
      "Optimisation énergétique",
      "Solutions évolutives et ouvertes",
    ],
    img: "/assets/real-domotique.jpg",
  },
  {
    id: "pompes-a-chaleur",
    num: "03",
    title: "Pompes à Chaleur, Clim & Chauffage",
    baseline: "Chauffe l'hiver, rafraîchit l'été",
    description:
      "Dimensionnement, fourniture et pose de pompes à chaleur air/air et de climatisation réversible mono ou multi-split. Un système économique qui capte l'énergie de l'air et réduit vos dépenses toute l'année.",
    features: [
      "PAC air/air : étude, dimensionnement & pose",
      "Climatisation réversible mono & multi-split",
      "Entretien, maintenance & dépannage",
      "Conseils économies d'énergie",
    ],
    img: "/assets/real-pac.jpg",
  },
  {
    id: "motorisation-portail",
    num: "04",
    title: "Motorisation de Portail",
    baseline: "Entrez chez vous sans descendre de voiture",
    description:
      "Moteurs de portails battants ou coulissants, neufs ou existants. Motorisations fiables, commandes radio ou filaires, télécommandes, digicodes et interphonie.",
    features: [
      "Portails battants & coulissants",
      "Commandes radio & filaires",
      "Digicode, interphone & visiophone",
      "Dépannage toutes marques",
    ],
    img: "/assets/moteur-portail.jpg",
  },
  {
    id: "volets-roulants",
    num: "05",
    title: "Volets Roulants Électriques",
    baseline: "Remplacement & motorisation sur mesure",
    description:
      "Changement de volets roulants usagés, moteurs de volets filaires ou radio, centralisation domotique. Confort, isolation et sécurité en un geste.",
    features: [
      "Remplacement de volets existants",
      "Moteurs filaires & radio",
      "Centralisation & programmation horaire",
      "Lames, coffres & manœuvres de secours",
    ],
    img: "/assets/volet-roulant.jpg",
  },
  {
    id: "bornes-recharge",
    num: "06",
    title: "Bornes de Recharge",
    baseline: "Hager & ABB, de 3,7 à 22 kW",
    description:
      "Installation de bornes de recharge Hager et ABB pour véhicules électriques et hybrides rechargeables, à domicile comme en entreprise. Une recharge sécurisée, conforme IRVE, adaptée à votre installation.",
    features: [
      "Bornes Hager & ABB de 3,7 à 22 kW",
      "Maison, copropriété & entreprise",
      "Gestion intelligente de la recharge",
      "Installation certifiée IRVE",
    ],
    img: "/assets/chantier-2.jpg",
  },
  {
    id: "vmc",
    num: "07",
    title: "Ventilation VMC",
    baseline: "Un air sain, une maison saine",
    description:
      "Pose et remplacement de VMC simple flux et double flux. Évacuez l'humidité, préservez votre isolation et respirez un air renouvelé en continu.",
    features: [
      "VMC simple flux hygroréglable",
      "VMC double flux",
      "Remplacement de groupes vétustes",
      "Gaines, bouches & équilibrage",
    ],
    img: "/assets/vmc.jpg",
  },
  {
    id: "securite-confort",
    num: "08",
    title: "Sécurité & Confort",
    baseline: "Interphones, Vigik, alarmes & détection",
    description:
      "Protégez et contrôlez l'accès à votre habitat, votre copropriété ou votre entreprise : interphones, visiophones, lecteurs Vigik, alarmes, détecteurs, caméras et éclairage extérieur.",
    features: [
      "Interphones & visiophones",
      "Contrôle d'accès Vigik — copropriétés",
      "Alarmes, détecteurs & caméras",
      "Éclairage extérieur sécurisé",
    ],
    img: "/assets/chantier-1.jpg",
  },
];

export const REALISATIONS = [
  {
    id: "tableau-refonte",
    title: "Refonte complète d'un tableau",
    category: "electricite",
    tags: ["NF C 15-100", "Rénovation"],
    img: "/assets/real-electricite.jpg",
  },
  {
    id: "pac-air-air",
    title: "Pompe à chaleur air/air",
    category: "chauffage",
    tags: ["PAC air/air", "Multi-split"],
    img: "/assets/real-pac.jpg",
  },
  {
    id: "borne-22kw",
    title: "Borne de recharge Hager",
    category: "bornes",
    tags: ["Hager", "IRVE"],
    img: "/assets/chantier-2.jpg",
  },
  {
    id: "interphone-vigik",
    title: "Interphone & contrôle Vigik",
    category: "securite",
    tags: ["Vigik", "Digicode"],
    img: "/assets/chantier-1.jpg",
  },
  {
    id: "portail-coulissant",
    title: "Portail coulissant motorisé",
    category: "portails",
    tags: ["Motorisation", "Digicode"],
    img: "/assets/moteur-portail.jpg",
  },
  {
    id: "volets-radio",
    title: "Volets roulants électriques",
    category: "portails",
    tags: ["Radio", "Centralisation"],
    img: "/assets/volet-roulant.jpg",
  },
  {
    id: "vmc-double-flux",
    title: "VMC double flux en rénovation",
    category: "vmc",
    tags: ["Double flux", "Qualité d'air"],
    img: "/assets/vmc.jpg",
  },
];

export const FILTERS = [
  { id: "tous", label: "Tous" },
  { id: "electricite", label: "Électricité" },
  { id: "domotique", label: "Domotique" },
  { id: "chauffage", label: "Chauffage & Clim" },
  { id: "portails", label: "Portails & Volets" },
  { id: "bornes", label: "Bornes" },
  { id: "securite", label: "Sécurité" },
  { id: "vmc", label: "VMC" },
];
